import QueryString from 'query-string'

import convertKeys from 'utils/convert-keys'
import { cognitoAxiosInstance } from 'config/axiosInstance'
import { getToken } from 'services/amplify/auth'
import { EXTERNAL_SURVEYS } from 'resources/endpoints'

const fetchExternalSurvey = async (provider, headers = {}, params = {}) => {
  let url = `${EXTERNAL_SURVEYS}${provider}`
  if (Object.keys(params).length !== 0) {
    const queryParams = QueryString.stringify(params)
    url += `?${queryParams}`
  }
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token, headers).get(url)
  return convertKeys.toCamel(data)
}

export default {
  fetchExternalSurvey,
}
